import { render, staticRenderFns } from "./TagReference.vue?vue&type=template&id=76171a8f&scoped=true"
import script from "./TagReference.vue?vue&type=script&lang=js"
export * from "./TagReference.vue?vue&type=script&lang=js"
import style0 from "./TagReference.vue?vue&type=style&index=0&id=76171a8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76171a8f",
  null
  
)

export default component.exports